import React from "react";
import Nav from "./Nav";
import Header from "./Header";
import Products from "./Products";
import Features from "./Features";
import Footer from "./Footer";

const Home = () => {
  return (
    <>
      <Nav></Nav>
      <Header></Header>
      <Products></Products>
      <Features></Features>
      <Footer></Footer>
    </>
  );
};

export default Home;
